import React from "react";

// Images & Icons
import PlayButton from "../images/icons/playButton.png";
import ContainerText from "./Container.js";

// titleAs="h1" when this section is the main heading of the page
const LearningVideosContent = ({ titleAs = "p" }) => {
  const Title = titleAs;

  return (
    <ContainerText
      props={
        <div className="videosContainer">
          <div className="webTitle header">
            <Title className={titleAs === "h1" ? "seoH1 seoH1Inherit" : undefined}>
              Watch our ISA Learning Videos
            </Title>
          </div>
          <div className="videosSubtitle title">
            <p>
              Gain insights about Sustainability and what we can do for future
              generations
            </p>
          </div>
          <div className="videosCard">
            <div className="videosEachCard">
              <iframe
                className="videosResponsive"
                loading="lazy"
                src="https://www.youtube.com/embed/jLozIXtrycQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="videosEachCard">
              <iframe
                className="videosResponsive"
                loading="lazy"
                src="https://www.youtube.com/embed/5ZQqKrnX77Y"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="videosEachCard">
              <iframe
                className="videosResponsive"
                loading="lazy"
                src="https://www.youtube.com/embed/guPAuU5oaWQ"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="videosEachCard">
              <iframe
                className="videosResponsive"
                loading="lazy"
                src="https://www.youtube.com/embed/11N-U57i6Dg"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <div className="videosEachCard">
              <iframe
                className="videosResponsive"
                loading="lazy"
                src="https://www.youtube.com/embed/ghB8QJVw2Ag"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
          <div className="videosExploreMore paragrafDesc">
            <a
              style={{ border: "1px solid black" }}
              href="https://www.youtube.com/channel/UCWsQCHf9PodPl-_V_GaYorg/featured"
              target="_blank"
              rel="noopener noreferrer"
            >
              Explore more <img src={PlayButton} alt="" />
            </a>
          </div>
        </div>
      }
    />
  );
};

export default LearningVideosContent;
